import { render } from "./SubscriptionSummaryWidget.vue?vue&type=template&id=1cdb1594"
import script from "./SubscriptionSummaryWidget.vue?vue&type=script&lang=js"
export * from "./SubscriptionSummaryWidget.vue?vue&type=script&lang=js"

import "./SubscriptionSummaryWidget.vue?vue&type=style&index=0&id=1cdb1594&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__